// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fcf200cf","476":"de4e7719"}[chunkId] + ".chunk.js";
};